export function prefersReducedMotion(): boolean {
  return (
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

export async function whenImageCanPaint(img: HTMLImageElement | null): Promise<void> {
  if (!img) return;
  if (typeof img.decode === "function") {
    try {
      await img.decode();
    } catch {
      /* broken or unsupported — still reveal */
    }
    return;
  }
  if (img.complete) return;
  await new Promise<void>((resolve) => {
    img.addEventListener("load", () => resolve(), { once: true });
    img.addEventListener("error", () => resolve(), { once: true });
  });
}

type HeroWaveWipeOptions = {
  duration?: number;
  ease?: string;
};

/**
 * Left-to-right clip wipe used by the home, Sydney, and London hero waves.
 */
export async function playHeroWaveWipe(
  wave: HTMLElement,
  isCancelled: () => boolean,
  options: HeroWaveWipeOptions = {},
): Promise<{ kill: () => void } | undefined> {
  const { duration = 1.45, ease = "power3.inOut" } = options;
  const { gsap } = await import("gsap");
  if (isCancelled()) return;

  gsap.set(wave, {
    autoAlpha: 1,
    clipPath: "inset(0 100% 0 0)",
  });
  await whenImageCanPaint(wave.querySelector("img"));
  if (isCancelled()) return;

  return gsap.to(wave, {
    clipPath: "inset(0 0% 0 0)",
    duration,
    ease,
    overwrite: true,
  });
}
